import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Signup.css';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';
import Notification from '../../components/Notification/Notification';
import publicAxios from '../../utils/axios/publicAxios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    firstname: '',
    lastname: '',
    email: '',
    phoneNumber: '',
    password: '',
    confirmPassword: '',
    gender: '',
    dateOfBirth: '',
    bio: '',
  });

  const [notification, setNotification] = useState({ type: '', message: '' });
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => {
      setNotification({ type: '', message: '' });
    }, 5000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async () => {
    try {
      setLoading(true);
      const { confirmPassword, ...dataToSend } = formData;
      const response = await publicAxios.post(`/public/sign-up`, dataToSend);

      const userId = response.data?.userId;
      if (userId) {
        localStorage.setItem('pendingUserId', userId);
        showNotification('success', response.data.message || 'Registration successful!');
        navigate(`/confirm-otp/${userId}`);
      } else {
        throw new Error('No user ID returned from server');
      }

      // Clear form
      setFormData({
        username: '',
        firstname: '',
        lastname: '',
        email: '',
        phoneNumber: '',
        password: '',
        confirmPassword: '',
        gender: '',
        dateOfBirth: '',
        bio: '',
      });
    } catch (error) {
      console.error('Registration error:', error.response?.data || error.message);
      showNotification('error', error.response?.data?.message || 'Registration failed.');
    } finally {
      setLoading(false);
      setShowConfirm(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      showNotification('error', 'Passwords do not match.');
      return;
    }
    setShowConfirm(true);
  };

  return (
    <div className="signup">
      {showConfirm && (
        <ConfirmDialog
          message="Are you sure you want to submit this registration?"
          onConfirm={handleFormSubmit}
          onCancel={() => setShowConfirm(false)}
          loading={loading}
        />
      )}

      <Notification
        type={notification.type}
        message={notification.message}
        onClose={() => setNotification({ type: '', message: '' })}
      />

      <form className="signup-form" onSubmit={handleSubmit}>
        <h2>Create an Account</h2>

        {[
          { label: 'Username', name: 'username', type: 'text' },
          { label: 'First Name', name: 'firstname', type: 'text' },
          { label: 'Last Name', name: 'lastname', type: 'text' },
          { label: 'Email', name: 'email', type: 'email' },
          { label: 'Phone Number', name: 'phoneNumber', type: 'tel' },
          { label: 'Date of Birth', name: 'dateOfBirth', type: 'date' },
        ].map(({ label, name, type }) => (
          <div className="form-group" key={name}>
            <label>{label}:</label>
            <input
              type={type}
              name={name}
              {...(name === 'phoneNumber' && {
                minLength: 11,
                maxLength: 11,
                pattern: '[0-9]{11}',
              })}
              value={formData[name]}
              onChange={handleChange}
              required
            />
          </div>
        ))}

        <div className="signup-form-group">
          <label>Gender:</label>
          <select name="gender" value={formData.gender} onChange={handleChange} required>
            <option value="">Select gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div className="signup-form-group">
          <label>Bio (optional):</label>
          <textarea
            name="bio"
            value={formData.bio}
            onChange={handleChange}
            rows="3"
            placeholder="Tell us about yourself..."
          />
        </div>

        <div className="signup-form-group signup-password-field">
          <label>Password:</label>
          <div className="signup-password-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <span
              className="signup-toggle-password"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>

        <div className="signup-form-group password-field">
          <label>Confirm Password:</label>
          <div className="signup-password-wrapper">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
            <span
              className="signup-toggle-password"
              onClick={() => setShowConfirmPassword((prev) => !prev)}
            >
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>

        <button type="submit" className="signup-btn" disabled={loading}>
          {loading ? 'Submitting...' : 'Sign Up'}
        </button>
      </form>
    </div>
  );
};

export default Signup;